module.exports = __webpack_public_path__ + "img/property.d274120a.svg";